import { AllLocationList } from "./AllLocationList";

export default AllLocationList;
